import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import EPValid from "../components/epPurchase/shop/valid/epValid";
import EPPrefactor from "../components/epPurchase/shop/prefactor/epPrefactor";
import EPFinal from "../components/epPurchase/shop/final/epFinal";
import EPReport from "../components/epPurchase/report/report-list/ep-report";

export const epPurchaseRoutes = [
	<Route
		key="ep-valid"
		path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Valid}
		element={<ProtectedRoute role={Roles.Dealer_EPPurchase_B2C} element={EPValid} />}
	/>,
	<Route
		key="ep-prefactor"
		path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.PreFactor}
		element={<ProtectedRoute role={Roles.Dealer_EPPurchase_B2C} element={EPPrefactor} />}
	/>,
	<Route
		key="ep-final"
		path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Shop + _adr.EPPurchase.Final}
		element={<ProtectedRoute role={Roles.Dealer_EPPurchase_B2C} element={EPFinal} />}
	/>,
	<Route
		key="ep-report"
		path={_adr.Root + _adr.EPPurchase.Index + _adr.EPPurchase.Report.Index + _adr.EPPurchase.Report.List}
		element={<ProtectedRoute role={Roles.Dealer_EPPurchase_ReportOne} element={EPReport} />}
	/>,
];
